import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Select, TextField, Typography, Grid, FormControlLabel, Button} from "@mui/material";


export const MessageContainer = styled("div")`
    height: 30em;
    text-align: center;
    background: white;
    border-radius: .5em;
    position: relative;
    top: .5em;

`;

export const Icon = styled("div")`
    padding-top: 3em;
    justify-content: center;
    display: grid;
`;

export const Title = styled("div")`
    padding-top: 1em;
    font-size: 1.7em;
`;

export const Subtitle = styled("div")`
    padding-top: 1em;
    color: #BBBBBB;
`;